import { P as ProgressSpinner, d as defineCustomElement$1 } from './p-9de1d6b5.js';
const OwcProgressSpinner = ProgressSpinner;
const defineCustomElement = defineCustomElement$1;
export { OwcProgressSpinner, defineCustomElement };